import HttpService from "./httpService";
import { RefreshTokenHandler } from "./refreshToken";
import HttpBearerService from "./httpBearerService";

export let axiosController = new AbortController();
export let axiosCacheController = new AbortController();

export const resetAxiosController = () => {
  axiosController = new AbortController();
};

export const resetAxiosCacheController = () => {
  axiosCacheController = new AbortController();
};

// Queue
export const refreshTokenHandler = new RefreshTokenHandler();

// Auth with cookie
export const axiosECS = new HttpService();

// Auth with bearer
export const axiosBearer = new HttpBearerService();
